<div class="siteOptions overviewSiteOptions" [class.siteOptions--disabled]="isLoadingTable">
  @if (workspaces$ | async; as workspaces) {
    <div [class.siteOptions__visible--disabled]="isLoadingTable">
      <pp-site-filter-dropdown [ppDataFetched]="ppDataFetched" class="filterDropdown" />
      <pp-button-dropdown
        [ppSrc]="EIconPath.ICON_GROUP_24"
        [ppText]="'group' | ppTranslate"
        [ppActive]="!!preferences.timeline?.group"
        (ppAction)="toggleGroupingDropdown('groupingDropdown')"
        ppTooltip
        id="groupingDropdown"
        data-m-target="Grouping button"
        [ppTitle]="'group' | ppTranslate"
      />

      <pp-timeframe-button />
      <pp-timeline-export-button />
    </div>
  }

  <div class="siteOptions__rightOptions">
    @if (ppDataFetched) {
      <pp-site-filter />

      <button
        class="resetTimelineButton"
        (click)="resetTimeline()"
        ppTooltip
        [ppTitle]="'reset_timeline_tooltip' | ppTranslate"
      >
        {{ 'reset_timeline' | ppTranslate }}
      </button>
    }

    @if (ppDataFetched) {
      <div class="options-pagination hideMobile">
        <span
          class="point-list__pagination siteOptions__pointsNumberText"
          aria-label="Timeline points count"
        >
          {{ 'showing' | ppTranslate }}
          {{ ppTimelinePointsLength }}
          {{ ppTimelinePointsLength === 1 ? 'point' : 'points' }}
        </span>
      </div>
    }
  </div>
</div>
